function scrollToReviews() {
  document.querySelector("#stamped-main-section").scrollIntoView({ behavior: "smooth" });
}

let reviews = document.querySelector(".product-ingo__reviews");

if (reviews) {
  reviews.addEventListener("click", function (event) {
    scrollToReviews();
  });
}

// When stamped content loads in accordion, change widget ID
// This was created as major work around to having two Stampted widgets on the page. (Plan is to move away from Stamped for this and other reasons)
document.addEventListener("DOMContentLoaded", function () {
  const checkInterval = setInterval(() => {
    const accordionWidget = document.querySelector(".product-info__accordion-reviews #stamped-main-widget");
    const hasStampedContent = accordionWidget?.querySelector(".stamped-container");

    if (accordionWidget && hasStampedContent) {
      console.log("Stamped content loaded, updating ID");
      accordionWidget.id = "stamped-main-widget-top";
      
      // Change the class name of the unwanted reviews container so Stamped pagination scrolls to the correct one
      const unwantedReviews = accordionWidget.querySelector(".stamped-reviews");
      if (unwantedReviews) {
        unwantedReviews.className = unwantedReviews.className.replace('stamped-reviews', 'stamped-reviews-top');
      }
      
      clearInterval(checkInterval);
    }
  }, 100);

  // Safety timeout after 10 seconds
  setTimeout(() => clearInterval(checkInterval), 10000);
});

// Handle star rating badge clicks
document.addEventListener(
  "click",
  function (event) {
    if (event.target.closest(".stamped-product-reviews-badge")) {
      event.preventDefault();
      event.stopImmediatePropagation();
      scrollToReviews();
    }
  },
  true
);

setTimeout(() => {
  const reviewsContainer = document.querySelector(".product-info__accordion-reviews");
  const reviewsBadge = document.querySelector(".stamped-badge-caption");

  const noReviewsInBadge = reviewsContainer && reviewsBadge && reviewsBadge.getAttribute("data-reviews") === "0";

  if (noReviewsInBadge) {
    const accordion = document.querySelector(".product-info__accordion-reviews");
    if (accordion) {
      accordion.classList.add("product-info__accordion-reviews--hidden");
    }
  }
}, "1500");
